import styles from 'styles/ActionBarAdvancedOptionsInputWrapper.module.css'

const SearchInputWrapper = ({ children }) => (
    <div className={styles.wrapper}>
        { children }
    </div>
)

export default SearchInputWrapper